import { useEffect } from 'react'

import { SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'

import { useFormWithSchema } from '@fortem-monorepo/react-spa'
import { Form } from '@fortem-monorepo/react-ui'

import { useAddAttributionEntryMutation } from '@/react-query/mutations/attributions'

import { type SchemaType, schema } from './AddAttributionEntryForm.schema'

export interface AddAttributionEntryFormProps extends Omit<UseFormProps<SchemaType>, 'resolver'> {
  children?: ((form: UseFormReturn<SchemaType>) => React.ReactNode) | React.ReactNode
  onSubmit?: SubmitHandler<SchemaType>
}

export const AddAttributionEntryForm: React.FC<AddAttributionEntryFormProps> = ({
  children,
  onSubmit,
  ...props
}) => {
  const form = useFormWithSchema({ mode: 'all', ...props }, schema)
  const input_type = form.watch('input_type')

  const addAttributionEntryMutation = useAddAttributionEntryMutation(form.getValues('input_type'))

  const submit = form.handleSubmit(
    onSubmit ??
      (async (_data, _e) => {
        await addAttributionEntryMutation.mutateAsync(_data.files)
        form.reset({ input_type, files: new DataTransfer().files })
        form.trigger()
      }),
  )

  useEffect(() => {
    form.trigger()
  }, [])

  return (
    <Form {...form}>
      <form onSubmit={submit}>{typeof children === 'function' ? children(form) : children}</form>
    </Form>
  )
}
